<template>
    <SparkListItem
        data-cy="events-item"
        :start-item="showDay ? 'date' : null"
        :start-date="displayDay"
        :class="{ 'cursor-pointer': event.link }"
        :bottom-divider="!isLast ? 'full' : null"
        :subtext="event.subtext"
        @click="onClick"
    >
        <template
            v-if="event.title"
            #title
        >
            <UIHtml
                :html="event.title"
                class="prose leading-5 text-[length:inherit] text-inherit"
                style="overflow-wrap: anywhere;"
            />
        </template>
        <template
            v-if="event.body"
            #description
        >
            <div
                v-if="event.body"
                class="content-sm-ux-regular mb"
            >
                <UIHtml
                    :html="event.body"
                    class="prose leading-5 text-[length:inherit] text-inherit"
                    style="overflow-wrap: anywhere;"
                />
            </div>
        </template>
    </SparkListItem>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import UIHtml from '@/components/ui/UIHtml.vue'
    import SparkListItem from '@/components/ui/SparkListItem.vue'

    const props = defineProps({
        day: Object,
        item: Object,
        isLast: Boolean,
        showDay: {
            type: Boolean,
            default: true,
        },
    })

    const router = useRouter()

    const moduleHelpers = useModuleHelpers()

    const clicking = ref(false)

    const event = computed(() => {
        return props.item
    })

    const start = computed(() => {
        return props.item.start
    })

    const displayDay = computed(() => {
        return props.showDay ? props.day ?? start.value : null
    })

    const onClick = () => {
        if (clicking.value || !event.value.link) {
            return
        }

        clicking.value = true
        moduleHelpers.openModuleOrOpenBrowserForLinkData(router, event.value.link)
            .catch((e) => {
                console.log('Failed to open link', e)
            })
            .finally(() => {
                clicking.value = false
            })
    }
</script>
